module.exports = __webpack_public_path__ + "static/health-coach-logo-f28d9b7afb6e04e4efa21b67fddcc109.png";